import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import {
  FormDropdown,
  InputField,
  NumberField,
} from "../../../../components/Stepper/fields/inputField";
import { debtType } from "../../../../utility/data";
import moment from "moment";

const LiabilityForm = ({ onSubmit, groupsData }) => {
  const [assetData, setAssetData] = useState({
    name: "",
    inclusion: groupsData[0] || null,
    linkedWith: "",
    debtType: debtType ? debtType[0].value : "",
    date: moment().toDate(),
    firstRank: "",
    Interest: "",
    period: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      onSubmit(assetData);
    } else {
      setFormErrors(errors);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!assetData.name) errors.name = "Name is required";
    if (!assetData.inclusion)
      errors.inclusion = "Inclusion details are required";
    if (!assetData.debtType) errors.debtType = "Debt type is required";
    if (!assetData.linkedWith) errors.linkedWith = "Linked With is required";
    if (!assetData.date) errors.date = "Date is required";
    if (!assetData.firstRank) errors.firstRank = "1st Rank is required";
    if (!assetData.Interest) errors.Interest = "Interest is required";
    if (!assetData.period) errors.period = "Period is required";
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAssetData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleDateChange = (e) => {
    setAssetData((prevData) => ({
      ...prevData,
      date: e.value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, date: "" }));
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-12rem)]">
      <h2 className="text-2xl font-semibold mb-6 text-lightPrimary dark:text-primary-gradient">General</h2>
      <form onSubmit={handleSubmit} className="flex flex-col flex-grow">
        <div className="grid md:grid-cols-2 gap-5 text-primary mb-8">
          <InputField
            label="Name*"
            placeholder="Enter your name"
            name="name"
            value={assetData.name}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.name}
          />

          <FormDropdown
            label="Include In*"
            value={assetData.inclusion}
            name="inclusion"
            onChange={handleInputChange}
            options={groupsData}
            optionsLabel="name"
            error={formErrors.inclusion}
            className={`w-full bg-transparent border border-info dark:border-gray-300 rounded-lg ${
              assetData.inclusion ? "asset_Dropdown" : ""
            }`}
            containerClassName="col-span-2"
            labelClassName="block mb-2 text-lg text-info dark:text-grey font-semibold"
            mainClassName="w-full"
            placeholder="Select an Included In"
          />
          <FormDropdown
            label="Debt Type*"
            value={assetData.debtType}
            name="debtType"
            onChange={handleInputChange}
            options={debtType}
            optionsLabel="name"
            error={formErrors.debtType}
            className={`w-full bg-transparent border border-info dark:border-gray-300 rounded-lg ${
              assetData.debtType ? "asset_Dropdown" : ""
            }`}
            containerClassName="col-span-2"
            labelClassName="block mb-2 text-lg text-info dark:text-grey font-semibold"
            mainClassName="w-full"
            placeholder="Select a debt type"
          />

          <InputField
            label="Linked With*"
            placeholder="Enter linked with"
            name="linkedWith"
            value={assetData.linkedWith}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.linkedWith}
          />
        </div>

        <div className="grid md:grid-cols-4 gap-5 text-primary mb-8 mt-16">
          <div className="">
            <div className="w-full flex space-x-4">
              <label
                htmlFor="date"
                className="block text-base font-medium text-info dark:text-grey font-semibold text-nowrap"
              >
                Date*
              </label>
              <div className="flex-1">
                <Calendar
                  id="date"
                  value={assetData.date}
                  onChange={handleDateChange}
                  className="asset_date w-full"
                  placeholder="Select a date"
                  dateFormat="dd/mm/yy"
                />
                {formErrors.date && (
                  <small className="text-red-500">{formErrors.date}</small>
                )}
              </div>
            </div>
          </div>

          <NumberField
            label="1st Rank*"
            name="firstRank"
            value={assetData.firstRank}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.firstRank}
          />

          <NumberField
            label="Interest*"
            name="Interest"
            value={assetData.Interest}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.Interest}
          />

          <NumberField
            label="Period*"
            name="period"
            value={assetData.period}
            onChange={handleInputChange}
            required={true}
            errors={formErrors.period}
          />
        </div>

        <div className="mt-auto flex md:justify-end justify-center">
          <button
            type="submit"
            className="px-6 py-2 dark:text-black bg-lightPrimary text-white dark:button-primary-gradient hover:bg-secondary rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default LiabilityForm;
